import styled from 'styled-components';
import { Form } from 'formik';

import { CLOSE_ICON_SIZE } from 'components/Wrapper';
import FlexDiv from 'components/FlexDiv';

export const Content = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 24px calc(${CLOSE_ICON_SIZE} * 2);
`;

export const ButtonsContainer = styled(FlexDiv)`
  > button {
    margin-left: 20px;
  }
`;
